import { render, staticRenderFns } from "./MemberListTable.vue?vue&type=template&id=f2b4d106&"
import script from "./MemberListTable.vue?vue&type=script&lang=js&"
export * from "./MemberListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports